var map = {
	"./diamond-1-no-shine.png": "fb6c",
	"./diamond-1-slotted.png": "22b6",
	"./diamond-1.png": "1c7f",
	"./diamond-2-no-shine.png": "30c0",
	"./diamond-2-slotted.png": "f17c",
	"./diamond-2.png": "9318",
	"./diamond-3-no-shine.png": "d629",
	"./diamond-3-slotted.png": "e092",
	"./diamond-3.png": "c05c",
	"./diamond-4-no-shine.png": "ab71",
	"./diamond-4-slotted.png": "65e4",
	"./diamond-4.png": "f124",
	"./diamond-shine.png": "e51a",
	"./diamond-slot.png": "57e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba7a";